var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"doc-name",class:{ 'small-tag': _vm.smallTag }},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }